import React from "react";
import { useNavigate } from "react-router-dom";
import COLORS from "../Helpers/utils";
import ComponentCard from "./ComponentCard";
import {BaseComponentImpl} from "../types/implementations";
import { Building } from "../types/protocols";

interface ComponentSectionProps {
    title: string;
    components: BaseComponentImpl[];
    building: Building;
    buildingKey: string;
    icon?: string;
    onMouseEnter?: (componentKey: string) => void;
    onMouseLeave?: () => void;
    hoveredKey?: string | null;
    onNavigate?: (componentKey: string) => void;
    selectedKey?: string | null;
}

const ComponentSection: React.FC<ComponentSectionProps> = ({
                                                               title,
                                                               components,
                                                               building,
                                                               buildingKey,
                                                               icon,
                                                               onMouseEnter,
                                                               onMouseLeave,
                                                               hoveredKey,
                                                               onNavigate,
                                                               selectedKey
                                                           }) => {
    const navigate = useNavigate();

    const handleNavigate = (componentKey: string) => {
        if (onNavigate) {
            onNavigate(componentKey);
        } else {
            navigate(`/building/${buildingKey}/component/${componentKey}`);
        }
    };

    let path = undefined
    if (icon) {
        path = `/Images/${icon}.png`;
    }

    return (
        <div>
            <div style={{display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px'}}>
                {path && <img src={path} style={{width: '24px', height: '24px'}}/>}
                <h3 style={{margin: 0}}>{title}</h3>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", backgroundColor: COLORS.lightGrey, padding: '20px', borderRadius: '10px' }}>
                {components.map((component, index) => (
                    <ComponentCard
                        key={index}
                        component={component}
                        building={building}
                        buildingKey={buildingKey}
                        onNavigate={handleNavigate}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        isHovered={hoveredKey === component.key}
                        isSelected={selectedKey === component.key}
                    />
                ))}
            </div>
        </div>
    );
};

export default ComponentSection;